import { Store } from '@ngxs/store';
import _ from 'lodash';
import { shortcutStringBuilder } from 'src/app/helper/shortcutStringBuilder';
import { DirectoryBrowserCallFromColumn } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.actions';
import {
   DirectoryBrowserAddEntry,
   DirectoryBrowserEditEntry,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.actions';
import { OpenAppointmentDialog } from 'src/app/store/samwin/appointment-dialog/appointment-dialog.actions';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { Enum, EnumType } from 'ts-jenum';
import { FeatureEnum } from '../../samwin/FeatureEnum';
import { Key } from './Keys';

@Enum<ShortcutTypeDirectory>('value')
export class ShortcutTypeDirectory extends EnumType<ShortcutTypeDirectory>() {
   constructor(
      public value,
      public translationKey: string,
      public columnName: string,
      public defaultHotkeyCombo: string,
      public hotkeyAction: (store: Store, brickId) => boolean
   ) {
      super();
   }

   static readonly DIAL_NUMBER_COLUMN = new ShortcutTypeDirectory(
      'DIAL_NUMBER_COLUMN',
      'navigation.hotkeys.directory.dial_column',
      'fld_orgnum',
      shortcutStringBuilder(...[Key.Ctrl, Key.Alt, Key.KeyN]),
      (store, brickId) => {
         {
            return ShortcutTypeDirectory.executeDialColumn(store, brickId, 'fld_orgnum');
         }
      }
   );

   static readonly DIAL_MOBILE_COLUMN = new ShortcutTypeDirectory(
      'DIAL_MOBILE_COLUMN',
      'navigation.hotkeys.directory.dial_column',
      'fld_sms',
      shortcutStringBuilder(...[Key.Ctrl, Key.Alt, Key.KeyM]),
      (store, brickId) => {
         {
            return ShortcutTypeDirectory.executeDialColumn(store, brickId, 'fld_sms');
         }
      }
   );

   static readonly DIAL_ALTERNATIVE_DEVICE_COLUMN = new ShortcutTypeDirectory(
      'DIAL_ALTERNATIVE_DEVICE_COLUMN',
      'navigation.hotkeys.directory.dial_column',
      'fld_altnst',
      shortcutStringBuilder(...[Key.Ctrl, Key.Alt, Key.KeyA]),
      (store, brickId) => {
         {
            return ShortcutTypeDirectory.executeDialColumn(store, brickId, 'fld_altnst');
         }
      }
   );

   static readonly OPEN_APPOINTMENT_DIALOG = new ShortcutTypeDirectory(
      'OPEN_APPOINTMENT_DIALOG',
      'navigation.hotkeys.directory.appointment_dialog',
      '',
      shortcutStringBuilder(...[Key.Ctrl, Key.Shift, Key.KeyA]),
      (store, brickId) => {
         // null means, open current selected entry (selecting the id here causes a circular dependency)
         // Note: This could theoretically cause the issue, that the id changes between pressing the shortcut
         // and processing the action.
         store.dispatch(new OpenAppointmentDialog(null, brickId));
         return true;
      }
   );

   static readonly ADD_DIRECTORY_ENTRY = new ShortcutTypeDirectory(
      'ADD_DIRECTORY_ENTRY',
      'navigation.hotkeys.directory.add_entry',
      '',
      shortcutStringBuilder(...[Key.Shift, Key.Alt, Key.KeyC]),
      (store, brickId) => {
         const isFeatureEnabled = store.selectSnapshot(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.DIRECTORY_ADD_CONTACT));
         const isAttendant = store.selectSnapshot(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.SAMWIN_7_ATTENDANT));
         if (isFeatureEnabled && isAttendant) {
            store.dispatch(new DirectoryBrowserAddEntry(brickId));
         }
         return true;
      }
   );

   static readonly EDIT_DIRECTORY_ENTRY = new ShortcutTypeDirectory(
      'EDIT_DIRECTORY_ENTRY',
      'navigation.hotkeys.directory.edit_entry',
      '',
      shortcutStringBuilder(...[Key.Shift, Key.Alt, Key.KeyE]),
      (store, brickId) => {
         const isFeatureEnabled = store.selectSnapshot(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.DIRECTORY_EDIT_CONTACT));
         const isAttendant = store.selectSnapshot(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.SAMWIN_7_ATTENDANT));
         if (isFeatureEnabled && isAttendant) {
            store.dispatch(new DirectoryBrowserEditEntry(brickId));
         }
         return true;
      }
   );

   static executeDialColumn(store: Store, brickId: string, columnName: string): boolean {
      const searchValue: string = _.last(columnName.split('_'));
      store.dispatch(new DirectoryBrowserCallFromColumn(brickId, searchValue));
      return true;
   }
}
